"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SeeMoreCommentsButton = exports.CommentsWrapper = exports.GridBordered = exports.MessageMediaWrapper = exports.CardActionsFullWidth = exports.CardActions = exports.CardHeader = exports.Card = exports.AvatarWrapper = exports.Wrapper = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Card = _interopRequireDefault(require("@material-ui/core/Card"));

var _CardHeader = _interopRequireDefault(require("@material-ui/core/CardHeader"));

var _CardActions = _interopRequireDefault(require("@material-ui/core/CardActions"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Button = _interopRequireDefault(require("../Button"));

var _colors = _interopRequireDefault(require("../../theme/colors"));

var _spacing = _interopRequireDefault(require("../../theme/spacing"));

function _templateObject10() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    margin-top: ", ";\n    margin-bottom: ", ";\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  padding: ", ";\n  border-bottom: ", ";\n\n  && > * {\n    margin-bottom: ", ";\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  border-top: ", ";\n  border-bottom: ", ";\n\n  & > *:first-child {\n    border-right: ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    margin-top: ", ";\n    > * {\n      margin-top: ", ";\n    }\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    padding: 0px 0px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    padding: ", " ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    padding-bottom: 0px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    border: ", ";\n    width: 100%;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  margin-right: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  width: 100%;\n  max-width: 540px;\n  min-width: 320px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var borderStyle = "1px solid ".concat(_colors["default"].lychee[300], ";");

var Wrapper = _styledComponents["default"].div(_templateObject());

exports.Wrapper = Wrapper;

var AvatarWrapper = _styledComponents["default"].div(_templateObject2(), _spacing["default"][2]);

exports.AvatarWrapper = AvatarWrapper;
var Card = (0, _styledComponents["default"])(_Card["default"])(_templateObject3(), borderStyle);
exports.Card = Card;
var CardHeader = (0, _styledComponents["default"])(_CardHeader["default"])(_templateObject4());
exports.CardHeader = CardHeader;
var CardActions = (0, _styledComponents["default"])(function (_ref) {
  var disableActionSpacing = _ref.disableActionSpacing,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["disableActionSpacing"]);
  return /*#__PURE__*/_react["default"].createElement(_CardActions["default"], props);
})(_templateObject5(), _spacing["default"][1], _spacing["default"][4]);
exports.CardActions = CardActions;
var CardActionsFullWidth = (0, _styledComponents["default"])(CardActions)(_templateObject6());
exports.CardActionsFullWidth = CardActionsFullWidth;

var MessageMediaWrapper = _styledComponents["default"].div(_templateObject7(), _spacing["default"][4], _spacing["default"][2]);

exports.MessageMediaWrapper = MessageMediaWrapper;
var GridBordered = (0, _styledComponents["default"])(_Grid["default"])(_templateObject8(), borderStyle, borderStyle, borderStyle);
exports.GridBordered = GridBordered;

var CommentsWrapper = _styledComponents["default"].div(_templateObject9(), _spacing["default"][4], borderStyle, _spacing["default"][2]);

exports.CommentsWrapper = CommentsWrapper;
var SeeMoreCommentsButton = (0, _styledComponents["default"])(_Button["default"])(_templateObject10(), _spacing["default"][1], _spacing["default"][1]);
exports.SeeMoreCommentsButton = SeeMoreCommentsButton;